export const catalogo = {
  cursos: { title: 'Catálogo · Cursos', description: 'Cursos disponíveis para você.' },
  trilhas: { title: 'Catálogo · Trilhas', description: 'Trilhas de aprendizado disponíveis.' },
  tabs: { cursos: 'Cursos', trilhas: 'Trilhas' },
  card: {
    matriculado: 'Matriculado',
    matricular: 'Matricular',
    continuar: 'Continuar',
    verDetalhes: 'Ver detalhes',
    comCertificado: 'Emite certificado',
  },
  empty: {
    cursos: 'Nenhum curso disponível no momento.',
    cursosDesc: 'Assim que novos cursos forem publicados, eles aparecem aqui.',
    trilhas: 'Nenhuma trilha disponível no momento.',
    trilhasDesc: 'Assim que novas trilhas forem publicadas, elas aparecem aqui.',
  },
  matricula: {
    sucessoCurso: 'Matrícula realizada no curso.',
    sucessoTrilha: 'Matrícula realizada na trilha.',
    prereqTitle: 'Você ainda não concluiu:',
    prereqHint: 'Pode seguir mesmo assim.',
    erroAtivaExistente: 'Você já está matriculado.',
    erroArquivado: 'Este conteúdo foi arquivado e não aceita novas matrículas.',
    erroNaoMatriculavel: 'Conteúdo indisponível.',
  },
  detalhe: {
    objetivo: 'Objetivo',
    tipoCurso: 'Curso',
    tipoTrilha: 'Trilha',
    modulosCount_one: '{{count}} módulo',
    modulosCount_other: '{{count}} módulos',
    cursosCount_one: '{{count}} curso',
    cursosCount_other: '{{count}} cursos',
    aulasCount_one: '{{count}} aula',
    aulasCount_other: '{{count}} aulas',
    modulos: 'Módulos',
    cursosDaTrilha: 'Cursos da trilha',
    aulas: 'aulas',
    progresso: 'Progresso',
    concluido: 'Concluído',
    iniciar: 'Iniciar',
    continuar: 'Continuar',
    matricularPara: 'Matricule-se para acessar o conteúdo.',
    opcional: 'Opcional',
    quizLabel: 'Quiz',
    videoLabel: 'Vídeo',
    textoLabel: 'Leitura',
    semConteudo: 'Nenhum conteúdo disponível ainda.',
  },
  emBreve: {
    selo: 'Em breve',
    dica: 'Disponível em breve',
    titulo: 'Esta aula chega em breve',
    descricao: 'Assim que ela for liberada, aparece aberta no conteúdo do curso.',
    voltarAoCurso: 'Voltar ao curso',
    irAoCatalogo: 'Ir para o catálogo',
  },
  player: {
    marcarConcluida: 'Marcar como concluída',
    concluida: 'Aula concluída',
    concluidaTitulo: 'Aula concluída!',
    concluidaSubtitulo: 'Mandou bem. Continue de onde parou.',
    proximaAula: 'Próxima aula',
    voltarAoCurso: 'Voltar ao curso',
    videoIndisponivel: 'Vídeo indisponível.',
    video: {
      rotulo: 'Vídeo da aula: {{titulo}}',
      legendaPt: 'Português (Brasil)',
      falhou: 'Não foi possível carregar o vídeo.',
      tentarDeNovo: 'Tentar de novo',
    },
    posicao: 'Aula {{atual}} de {{total}}',
    conteudoDoCurso: 'Conteúdo do curso',
    aulaAnterior: 'Aula anterior',
    navegacaoAulas: 'Navegação entre aulas',
    aulaAnteriorLabel: 'Aula anterior: {{titulo}}',
    proximaAulaLabel: 'Próxima aula: {{titulo}}',
    quiz: {
      titulo: 'Quiz',
      intro: 'Responda às questões para concluir esta aula.',
      iniciar: 'Iniciar quiz',
      retomar: 'Retomar tentativa',
      restantes_one: '{{count}} tentativa restante',
      restantes_other: '{{count}} tentativas restantes',
      ilimitado: 'Tentativas ilimitadas',
      notaMinima: 'Nota mínima: {{score}}%',
      questaoDe: 'Questão {{atual}} de {{total}}',
      respondidasDe: '{{atual}} de {{total}} respondidas',
      irPendente: 'Ir para questão pendente',
      ultimaTentativa: 'Última tentativa',
      verdadeiro: 'Verdadeiro',
      falso: 'Falso',
      enviar: 'Enviar respostas',
      enviando: 'Enviando...',
      anterior: 'Anterior',
      proxima: 'Próxima',
      resultadoTitulo: 'Resultado',
      aprovado: 'Aprovado!',
      reprovado: 'Não atingiu a nota mínima',
      suaNota: 'Sua nota: {{score}}%',
      refazer: 'Refazer quiz',
      gabarito: 'Gabarito',
      suaResposta: 'Sua resposta',
      respostaCorreta: 'Resposta correta',
      semResposta: 'Sem resposta',
      tentativasEsgotadas: 'Você esgotou as tentativas. Peça ao professor para reabrir.',
      notaRepresentativa: 'Sua nota: {{score}}%',
    },
  },
  inicio: {
    saudacao: {
      manha: 'Bom dia, {{nome}}',
      tarde: 'Boa tarde, {{nome}}',
      noite: 'Boa noite, {{nome}}',
    },
    subtitulo: {
      ativos_one: 'Você tem {{count}} aprendizado em andamento.',
      ativos_other: 'Você tem {{count}} aprendizados em andamento.',
      tudoEmDia: 'Você está em dia. Que tal aprender algo novo?',
      boasVindas: 'Vamos começar sua jornada de aprendizado.',
    },
    spotlight: {
      overline: 'Continuar aprendendo',
      proximaLabel: 'Próxima aula:',
    },
    stats: {
      emAndamento: 'Em andamento',
      concluidos: 'Concluídos',
      certificados: 'Certificados',
    },
    listaTitulo: 'Seus aprendizados',
    explore: {
      titulo: 'Pronto para aprender algo novo?',
      descricao: 'Explore o catálogo e encontre seu próximo curso ou trilha.',
      cta: 'Explorar catálogo',
    },
    welcome: {
      titulo: 'Bem-vindo ao NT Academy, {{nome}}!',
      descricao:
        'Este é o seu espaço para crescer. Comece escolhendo um curso ou trilha no catálogo.',
      cta: 'Explorar catálogo',
    },
  },
  progresso: {
    continuar: 'Continuar',
    revisar: 'Revisar',
    atribuidoPor: 'Atribuído por {{nome}}',
    prazo: 'Prazo: {{data}}',
    proximaAula: 'Próxima aula: {{titulo}}',
    cancelar: 'Cancelar matrícula',
    cancelarTitle: 'Cancelar esta matrícula?',
    cancelarDescription: 'Seu progresso nesta matrícula auto-feita será removido.',
    cancelado: 'Matrícula cancelada.',
    concluido: 'Concluído',
    concluidoEm: 'Concluído em {{data}}',
    maisOpcoes: 'Mais opções',
  },
} as const;
